export default {
	"coupon.ThereAreNoCoupons": "暫無相關優惠券",
	"coupon.Loading": "載入...",
	"coupon.NoMore": "沒有更多了~"
}